export class PortateHead {
  uid: string;
  titolo_en: string;
  titolo_it: string;
  descrizione_en: string;
  descrizione_it: string;
}
